/**
 * @description API基础URL配置
 * test121的服务都修改网关、服务端控制去proxy_pass为1v1api
 * 除了testpc、testapi的所有服务都转为请求1v1api（线上vip1v1）服务
 * 1v1api内网不能直接请求，改为https://test121.meishubao.com/1v1_client_gateway
 * 
 * @note 原服务可从proxy配置查看，注意本地proxy是不生效的
 * 如果不是直接请求的完整服务地址，都是请求的test121服务，服务端再根据前缀匹配、proxy_pass分配到各个服务
 */

/** 环境类型定义 */
type Env = "dev" | "test" | "live";

/** URL配置对象类型 */
type UrlConfig = Record<Env, string>;

/** 当前环境 */
const env: Env = import.meta.env.VITE_APP_ENV;

/** 是否为开发环境 */
const isDev = import.meta.env.MODE === "development";

/** 主服务URL配置 */
const urlList: UrlConfig = {
  dev: "https://test121.meishubao.com",
  test: "https://test121.meishubao.com",
  live: "https://vip.meishubao.com"
};

/** testapi服务URL配置 */
const urlList2: UrlConfig = {
  dev: "https://testapi.meishubao.com",
  test: "https://testapi.meishubao.com",
  live: "https://onlineapi.meishubao.com"
};

/** PC端服务URL配置 */
const urlList4: UrlConfig = {
  dev: "https://javaapipc.meishubao.com",
  test: "https://testpc.meishubao.com",
  live: "https://onlinepc.meishubao.com"
};

/** 兑吧服务URL配置 */
const urlList12: UrlConfig = {
  dev: "/duiba",
  test: "/duiba",
  live: "/duiba"
};

/** MSC网关服务URL配置 */
const urlList13: UrlConfig = {
  dev: "/vip-app-dev/api/vipappmscgate/api",
  test: "/vip-app-dev/api/vipappmscgate/api",
  live: "/vip-app-live/api/vipappmscgate/api"
};

/** GraphQL前端服务URL配置 */
const urlList15: UrlConfig = {
  dev: "/gql",
  test: "/gql",
  live: "/gql"
};

/** 打卡服务URL配置 */
const urlList17: UrlConfig = {
  dev: "/1v1app/dbk/api",
  test: "/1v1app/dbk/api",
  live: "/1v1app/dbk/api"
};

/** 埋点追踪服务URL配置 */
const urlList18: UrlConfig = {
  dev: "https://track-dev.meishubao.com",
  test: "https://track-test.meishubao.com",
  live: "https://track.meishubao.com"
};

/** 小熊服务URL配置 */
const urlList19: UrlConfig = {
  dev: "/mop",
  test: "/mop",
  live: "/mop"
};

/** 新网关基础路径 */
export const newBaseUrl = "/1v1_client_gateway";

/**
 * 使用相对路径的域名白名单
 * @description 这些域名下直接使用相对路径请求，无需拼接完整域名；新增域名只需往数组里加即可
 */
const RELATIVE_PATH_HOSTS = [
  // 美术宝网校H5线上环境(固定时段)
  "artboss.meishubao.com",
  // 水木源网校H5线上环境(固定时段)
  "smy.meishubao.com",
  // 美术宝网校线上H5支付域名
  "wx.meishuvip.com",
  // 水木源网校线上H5支付域名
  "smy.meishuvip.com",
];

/**
 * 主服务基础URL
 * @description 开发环境或白名单域名使用相对路径（空串），其他环境使用完整域名
 */
export const baseURL = (isDev || RELATIVE_PATH_HOSTS.includes(window.location.host)) ? "" : urlList[env];
console.log(import.meta.env.MODE, "🚀 ~ baseUrl.ts ~ baseURL:", baseURL, isDev);

/** 商城服务 */
export const baseURL1 = newBaseUrl + "/client/php/store";

/** testapi服务 */
export const baseURL2 = urlList2[env];

/** PC端服务 */
export const baseURL4 = urlList4[env];

/** C端PHP服务 */
export const baseURL5 = newBaseUrl + "/client/php/c";

/** 运营服务 */
export const baseURL6_1 = newBaseUrl + "/client/operation_service/operation";

/** 问题中心服务 */
export const baseURL6_2 = newBaseUrl + "/client/question_center/question";

/** 物流服务 */
export const baseURL7 = newBaseUrl + "/logistics/c";

/** 教师管理服务 */
export const baseURL8 = newBaseUrl + "/client/tea_management";

/** UMS API服务（带路径） */
export const baseURL9 = newBaseUrl + "/client/ums_api/a/p";

/** 1v1app服务 */
export const baseURL10 = "/1v1app";

/** UMS API服务 */
export const baseURL11 = newBaseUrl + "/client/ums_api";

/** 兑吧服务 */
export const baseURL12 = urlList12[env];

/** MSC网关服务 */
export const baseURL13 = newBaseUrl + urlList13[env];

/** UMS API服务（备用） */
export const baseURL14 = newBaseUrl + "/client/ums_api";

/** GraphQL服务 */
export const baseURL15 = urlList15[env];

/** 教师管理服务（备用） */
export const baseURL16 = newBaseUrl + "/client/tea_management";

/** 打卡服务 */
export const baseURL17 = urlList17[env];

/** 埋点追踪服务 */
export const baseURL18 = urlList18[env];

/** 小熊服务 */
export const baseURL19 = urlList19[env];

/** 音乐宝K8S服务 */
export const baseURL20 = "/yybk8s";

/** 1v1 K8S服务 */
export const baseURL21 = "/1v1k8s";

/** Boss端PHP服务 */
export const newBaseUrlClientPhpBoss = newBaseUrl + "/client/php/boss";
